import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardHeader, Media, Table, Row, Button, Input } from "reactstrap";
import { addPrinter, getPrinter } from '../../utils/middleware/categories'; // API call
import NoDataLabel from "../../../../components/NoDataLabel";
import { getCategoriesList } from '../../utils/middleware/products';
import CustomPagination from "../../../../components/Pagination";

export default function Tables() {
  const { categories } = useSelector((state) => state.restaurantAdminProducts);

  // State
  const [updatedPrinters, setUpdatedPrinters] = useState({}); // <== New state
const [printerData, setPrinterData] = useState([]); // ✅ Array, not {}


  useEffect(() => {
    getCategoriesList();
  }, []);

  useEffect(() => {
    getPrinter().then((res) => {
      const apiData = res.data.data.rows;
      let printerNameData = [];
      categories.map((category) => {
        if (category.isParentCategory) {
          printerNameData.push({
            label: category.label,
            value: category.value,
            isParentCategory: category.isParentCategory,
            printerName: apiData.find(e=> e.parentCategoryId === category.value)?.printerName,
          });
        }
      })
      setPrinterData(printerNameData);
    });
  }, [categories]);

  const handleInputChange = (categoryId, value) => {
    setUpdatedPrinters(prev => ({
      ...prev,
      [categoryId]: value
    }));
  };

  const handleSubmit = async (category) => {
    console.log("category", category);
    const printerName = category.printerName;

    const payload = {
      printerName: printerName,
      parentCategory: category.value,
    }

    console.log("body", payload);
    // Call the API to add the printer
    try {
      addPrinter(payload); // your API call
      console.log("Printer added successfully", payload);
    } catch (error) {
      console.error("Error adding printer", error);
    }
  };

  let i = 1;

  return (
    <div>
      <div className="custom-container">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 space-between-div table-header-div">
                <h3>Printers</h3>
              </CardHeader>
              {categories.length !== 0 ? (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">No</th>
                      <th scope="col">Category Name</th>
                      <th scope="col">Printer Name</th>
                      <th scope="col" className="text-right">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {printerData.map((table, index) =>
                      table.isParentCategory ? (
                        <tr key={table.id}>
                          <th scope="row">
                            <Media className="align-items-center">
                              <Media>
                                <span className="mb-0 text-sm">{i++}</span>
                              </Media>
                            </Media>
                          </th>
                          <td>{table.label}</td>
                          <td>
                            <Input
                              type="text"
                              value={table.printerName || ""}
                              onChange={(e) => {
                                handleInputChange(table.id, e.target.value);
                                table.printerName = e.target.value;
                              }}
                            />
                          </td>
                          <td className="text-right">
                            <div className="flex align-items-center justify-content-end">
                              <Button
                                className="btn-icon btn-2"
                                color="primary"
                                type="button"
                                onClick={() => handleSubmit(table)}
                              >
                                Submit
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ) : null
                    )}
                  </tbody>
                </Table>
              ) : (
                <NoDataLabel />
              )}
              <CustomPagination totalCount={0} page={1} />
            </Card>
          </div>
        </Row>
      </div>
    </div>
  );
}
